<template>
  <div>
   <div class="purchase_search">
      <table-search
      :fileds="SearchFiledNew"
      :form="queryForm"
      @search="handleSearch"
      @reset="handleReset"
      @onSearch="onSearchProject"
      @checkedList="checkedList"
      @WhChange="handleWhChange">
    </table-search>
   </div>
   <div class="purchase_table">
     <div class="operate_bar">
        <a-button class="btn_export" @click="handleExport">导出</a-button>
     </div>
      <a-table
        :columns="TableColumns"
        :data-source="goodsData"
        size="middle"
        row-key="id"
        :scroll="{ x: 'calc(700px + 50%)'}"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template slot="goodsName" slot-scope="text">
            <a-tooltip placement="topLeft" :title="text">
               <span>{{text}}</span>
            </a-tooltip>
        </template>
        <template slot="shipperGoodsCode" slot-scope="text">
            <a-tooltip placement="topLeft" :title="text">
               <span>{{text}}</span>
            </a-tooltip>
        </template>
        <template slot="batchNo" slot-scope="text">
            <a-tooltip placement="topLeft" :title="text">
               <span>{{text}}</span>
            </a-tooltip>
        </template>
      </a-table>
   </div>
  </div>
</template>

<script>
import TableSearch from '@/components/TableSearch/index.vue'
import moment from 'moment'
import { EventBus } from '@/utils/event-bus'
import {getSignType} from "@/api/enterprise/authentication";
import { mapMutations } from 'vuex'
import {SearchFiled,TableColumns,IS_ABNORMAL} from './constant'
import {stockHistoryReport,stockHistoryExport} from '../overview/api'
import {getCustomerList, getWareHouse} from '../../warehouseOrder/api'

  export default {
    name:'PurchaseSaleStock',
    components:{
      TableSearch,
    },
    data(){
      return {
        queryForm:{
          createTime:[moment().subtract(7, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')]
        },
        SearchFiled,
        TableColumns,
        IS_ABNORMAL,
        goodsData:[],
        isEnterprise:false,
        ProjectList: [],
        pagination: {
          current: 1,
          total: 0,
          pageSize:10,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          onShowSizeChange: (current, pageSize) => {
            this.pagination.pageSize = pageSize
          },
          showQuickJumper: true,
          showTotal: total => `共 ${total} 条`
      },
      }
    },
    computed:{
      SearchFiledNew(){
        return [
          {
            label:'仓库',
            name:'warehouseCode',
            type:this.isEnterprise?'selectDom':'selectDom',
            prop:{
              list:this.ProjectList
            },
          },
          ...this.SearchFiled
        ]
      }
    },
    created(){
      const {creditCode}=this.$store.state.user
      this.isEnterprise=!!creditCode
      if(!creditCode){
        this.getWareHouse()
      }else {
        this.getCarrierList()
      }
    },
    methods:{
      ...mapMutations('user', ['SET_USER_DATA']),
      async getCarrierList(){
        const {customers} =this.$store.state.user
        const params=customers.map(item=>item.customerId)
        const data={
          ids:params,
        }
        const res= await getSignType(data)
        this.TenantList=res.map(item=>{
          return {
            ...item,
            value:item.customerCode,
            label:item.customerName,
            children:[]
          }
        })
        this.saveCarrier(res[0])
        this.getWareHouse()
      },
      saveCarrier(select){
        const {carrierTenantId,carrierTenantName,id,customerCode,customerName}=select
        const {customers}=this.$store.state.user
        const accountData={
          id:customers.filter(item=>item.customerId===id)[0].orgId,
          identityId:customerCode
        }
        localStorage.setItem('accountData',JSON.stringify(accountData))
        const selectCarriering={
          tenantId:carrierTenantId,
          tenantName:carrierTenantName,
          customerId:id,
          customerCode,
          customerName,
        }
        Object.keys(selectCarriering).forEach(item=>{
          this.SET_USER_DATA([item,selectCarriering[item]])
        })
      },
      handleWhChange(data){
         this.queryForm.warehouseCode = data.tenantId
          this.queryForm.shipperId = data.customerId
          this.ProjectList=[data]
           this.getData()
      },
     async handleExport(){
        const {createTime,abnormal,...restParmas}=this.queryForm
        const data={
          ...restParmas,
          startTime:new Date(createTime[0]).getTime(),
          endTime:new Date(createTime[1]).getTime()
          }
        if(abnormal){
          data.abnormal=IS_ABNORMAL[abnormal]
        }
        await stockHistoryExport(data)
        EventBus.$emit('taskPopover')
      },
      handleTableChange(pagination) {
        this.pagination = {
          ...this.pagination,
          current: pagination.current
        }
        this.getData();
      },
    async getData(){
      const {createTime,abnormal,...restParmas}=this.queryForm
      const data={
          ...restParmas,
          dateStart:new Date(createTime[0]).getTime(),
          dateEnd:new Date(createTime[1]).getTime()
        }
      if(abnormal){
        data.abnormal=IS_ABNORMAL[abnormal]
      }
      const parmas={
        page:this.pagination.current,
        size:this.pagination.pageSize
      }
     try {
        const res= await stockHistoryReport(data,parmas)
      this.goodsData=res.records
      this.pagination.total=res.total
     } catch (error) {
        this.goodsData=[]
        this.pagination.total=0
     }
      },
      onSearchProject(tenantName){
        this.getWareHouse(tenantName)
      },
      checkedList(data){
        this.queryForm.shipperId = data.customerId
        this.getData()
      },
      handleSearch(form){
        this.pagination.current=1
        this.queryForm={
          ...form,
        }
        this.getData();
      },
      handleReset(){
        this.queryForm={
          createTime:[moment().subtract(7, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
          warehouseCode: this.ProjectList[0].tenantId,
          shipperId: this.ProjectList[0].customerId,
        }
        this.pagination.current=1
        this.getData();
      },
      async getCustomerList() {
        const data = {
          identityIds: [this.$store.state.user.customerId],
          type: 'ORG',
          needCustomerInfo: true,
          needRelation: true,
          carrierTenantId: this.$store.state.user.tenantId
        }
        const params = {
          page: 1,
          size: 200,
        }
        const res = await getCustomerList(data, params)
        const customerCodes = []
        res.records.forEach((e) => {
          if (e.customerInfo) {
            customerCodes.push(e.customerInfo.customerCode)
            if (e.childrenOrg && e.childrenOrg.length > 0) {
              e.childrenOrg.forEach((n) => {
                if (n.customerInfo?.customerCode) {
                  customerCodes.push(n.customerInfo?.customerCode)
                }
              })
            }
          } else {
            customerCodes.push(this.$store.state.user.customerCode)
          }
        })
        return customerCodes
      },
      async getWareHouse(tenantName=null){
        const customerCodes = this.isEnterprise? this.$store.state.user.customers.map(item=>item.customerCode)  : [this.$store.state.user.customerCode]
        const data = {
          customerCodes,
          needExcludeDefaultTenant: true,
          tenantName,
          needGroupByTenantId:false,
          isReadConfig:true
        }
        getWareHouse(data,{size:500}).then((res) => {
        if(res.records.length <= 0){
          this.ProjectList = []
          return
        }
        const arr = res.records.map((e) => {
            return {
                ...e,
                label: e.tenantName,
                value: e.tenantId
            }
        })
        this.ProjectList = arr
        if(this.goodsData.length <= 0){
          if(arr.length > 0 ){
            this.queryForm.warehouseCode = arr[0].tenantId
            this.queryForm.shipperId = arr[0].customerId
          }
          this.getData()
        }
      })
    },
    }
  }
</script>

<style lang="less" scoped>
.purchase_search {
  background-color: #fff;
  border-radius: 6px;
  padding: 32px 12px 12px;
  margin-bottom: 20px;
  /deep/.ant-calendar-picker {
    width: 100% !important;
  }
}
.purchase_table {
  background-color: #fff;
  border-radius: 6px;
  padding: 24px;
  margin-bottom: 24px;
  .operate_bar {
    margin-bottom: 24px;
     .btn_export {
      border: 1px solid #06B880;
      color: #06B880;
    }
  }
}

</style>
